import React, { useMemo }       from 'react';
import { Field }                from 'redux-form';
import classNames               from 'classnames';
import { createTextMask }       from 'redux-form-input-masks';
import { useTranslation }       from 'react-i18next';
import { getCountryIdsByPhone } from '../../../tools/validityPhone';
import { preparePhoneNumber }   from '../../../tools/validityPhone';

import BaseField from './base/BaseField';
import ErrorIcon from '../../icons/ErrorIcon';

const phoneMask = t => createTextMask({
  pattern:         t('contact_phone_mask'),
  stripMask:       false,
  allowEmpty:      true,
  maskDefinitions: {
    '#': { regExp: /[0-9]/ },
  },
});

export const RenderPhoneField = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Field
      component={FieldWrapper}
      type={'text'}
      {...props}
      {...(props.hiddenMask ? {} : phoneMask(t))}
    />
  );
};

const FieldWrapper = (props) => {
  const {
          input,
          label,
          required,
          meta: {
                  touched,
                  error,
                },
        } = props;

  const { t } = useTranslation();

  const country     = useMemo(() => getCountryIdsByPhone(input.value)
    .at(0), [input.value]);
  const maskedValue = useMemo(() => preparePhoneNumber(country, input.value), [country, input.value]);

  return (
    <div
      className={classNames('field', {
        'empty':                  input.value === '',
        'error':                  touched && error,
        'show_placeholder_color': maskedValue.replace(/_/g, '#') === t('contact_phone_mask'),
      })}
    >
      <BaseField {...props} input={{
        ...input,
        value: maskedValue,
      }}
      />
      <label>{label}{required && ' *'}</label>
      {touched && error && (
        <span className={'error'}><ErrorIcon />{error}</span>)}
    </div>
  );
};